import React from 'react';
import Css from './TakeTop.module.css';
import { FaRegArrowAltCircleUp } from "react-icons/fa";

export default function TakeTop() {
  return (
    <div className={Css.container}>
      <span><a className={Css.icon} href="#Home"><FaRegArrowAltCircleUp /></a></span>
    </div>
  )
}
